import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "fixed inset-0 splash",
  ref: "splashRef"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "absolute top-0 left-0 right-0 p-4 md:p-8 gap-y-6" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "/assets/images/logo-white.png",
    class: "md:w-40"
  })
], -1)
const _hoisted_3 = {
  key: 0,
  id: "screen-1",
  class: "fadeIn"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "absolute inset-0 flex items-center justify-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "/assets/images/my-topia.png",
    class: "w-4/5 md:w-2/4"
  })
], -1)
const _hoisted_5 = {
  key: 1,
  id: "screen-2",
  class: "fadeIn"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "absolute inset-0 flex flex-col items-center justify-center text-white" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "text-center",
    style: {"max-width":"80%"}
  }, [
    /*#__PURE__*/_createVNode("img", {
      src: "/assets/images/waterline.png",
      class: "w-full mx-auto mb-2",
      style: {"max-width":"400px"}
    }),
    /*#__PURE__*/_createVNode("p", null, " Our mission is to give the Humber a global relevance by working together to develop the region as a demonstrator of a zero carbon economy. ")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "absolute bottom-0 left-0 right-0 grid grid-cols-2 p-4 md:p-8 gap-y-6" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "/assets/images/edenic.png",
    class: "w-32"
  }),
  /*#__PURE__*/_createVNode("img", {
    src: "/assets/images/clay10_white.png",
    class: "w-32 ml-auto"
  })
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.screenOneActive)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    (_ctx.screenTwoActive)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    _hoisted_7
  ], 512))
}